
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Home'
})
export default class Home extends Vue {}
